import { call } from "./APIs";


const makeCall = async (action,comment = "") => {
  const table = localStorage.getItem("call");
  console.log("Making call with action:", action);
  if (!table) {
    console.error("No table found in localStorage");
    return;
  }
  const tableNumber = table.split("=")[1];
  const response = await call({
    type: action,
    comment : comment,
    mac: localStorage.getItem("visitorId"),
    restaurantId: localStorage.getItem("restaurantId"),
    tableHash: tableNumber
  });
  console.log("Call response:", response);
  if(!response.data) alert(`Table ${tableNumber} is not available for this action.`);
  return response;
};

export {
    makeCall
}
